import { render } from "./pdfPreviewDialog.vue?vue&type=template&id=c8a88040&scoped=true"
import script from "./pdfPreviewDialog.vue?vue&type=script&lang=js"
export * from "./pdfPreviewDialog.vue?vue&type=script&lang=js"

import "./pdfPreviewDialog.vue?vue&type=style&index=0&id=c8a88040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a88040"]])

export default __exports__